<template>
  <div class="school-navigation">
    <v-navigation-drawer width="100%" permanent>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title"> منو کاربری </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          router
          :to="{ name: item.router, query: {} }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "navigation-component",
  data: () => {
    return {
      items: [
        {
          title: "گزارشات کاربران",
          icon: "mdi-account-details-outline",
          router: "UsersReport"
        },
        {
          title: "میزان فروش کلی",
          icon: "mdi-cash",
          router: "Payments"
        },
        {
          title: "گزارشات آزمون ها",
          icon: "mdi-clipboard-list-outline",
          router: "ExamsReport"
        },
        {
          title: "گزارشات مالی",
          icon: "mdi-cash-multiple",
          router: "PaymentsReport"
        },
        {
          title: "نمایندگی ها",
          icon: "mdi-face-agent",
          router: "Agents"
        },
        {
          title: "تستر ها",
          icon: "mdi-test-tube",
          router: "Tester"
        },
        {
          title: "ناظر",
          icon: "mdi-food-drumstick",
          router: "Supervisors"
        },
        {
          title: "درخواست جدید",
          icon: "mdi-book-open-page-variant-outline",
          router: "ActiveSchools"
        },
        {
          title: "مدارس تایید شده",
          icon: "mdi-card-account-details-outline",
          router: "ActivedSchools"
        },
        {
          title: "پورتال ها",
          icon: "mdi-earth",
          router: "Portals"
        }
      ]
    };
  }
};
</script>
